// react + dependencies
import React from "react";
import { Helmet } from "react-helmet";
import ContactForm from "../components/ui/ContactForm";
import { TbChristmasTree } from "react-icons/tb";

const Kontakt = () => {
  return (
    <>
      <Helmet>
        <title>Kontakt - Kavalier Photography</title>
        <meta
          name="description"
          content="Kontakt na rodinnou a reportážní fotografku z Českého Ráje. Rezervace focení, dotazy a informace. Těším se na setkání!"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.kavalierphotographer.cz/kontakt"
        />
        <meta property="og:title" content="Kontakt - Kavalier Photography" />
        <meta
          property="og:description"
          content="Kontakt na rodinnou a reportážní fotografku z Českého Ráje. Rezervace focení, dotazy a informace."
        />
        <meta
          property="og:image"
          content="https://www.kavalierphotographer.cz/assets/logo/AK_black.webp"
        />
        <meta
          property="og:image:alt"
          content="Kavalier Photography - AK Logo"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.kavalierphotographer.cz/kontakt"
        />
        <meta
          property="twitter:title"
          content="Kontakt - Kavalier Photography"
        />
        <meta
          property="twitter:description"
          content="Kontakt na rodinnou a reportážní fotografku z Českého Ráje. Rezervace focení, dotazy a informace."
        />
        <meta
          property="twitter:image"
          content="https://www.kavalierphotographer.cz/assets/logo/AK_black.webp"
        />

        <link
          rel="canonical"
          href="https://www.kavalierphotographer.cz/kontakt"
        />
      </Helmet>

      <section className="w-full my-0 md:my-10">
        <div className={`w-full`}>
          <div className="h-full container flex flex-col md:flex-row items-start justify-between">
            {/* left */}
            <div className="w-full md:w-4/12 relative md:sticky top-0 pt-6">
              <div className="pl-0 mr-0 md:mr-10 pt-6 md:pt-10 border-t border-[var(--cerna)]">
                <div>
                  <h3 className="text-3xl font-bold mb-4">Kontakt</h3>
                  <p>
                    Pro kontaktování buď použijte kontaktní formulář nebo
                    sociální sítě či přímý email přes odkazy níže.
                  </p>
                </div>
                {/* 
                <div>
                  <div>
                    <p>
                      Na vánoční focení je možné se objednat přímo přes odkaz
                      níže.
                    </p>
                  </div>
                  <div className="mt-4 md:mt-8">
                    <a
                      href="https://adela-kavalirova.reservio.com/booking"
                      target="_blank"
                      rel="noreferrer"
                      className="btn-primary flex items-center w-fit gap-2"
                    >
                      <TbChristmasTree className="w-4 h-4 text-white " />
                      objednat
                    </a>
                  </div>
                </div>
                  */}
              </div>
            </div>

            {/* right */}
            <div className="w-full md:w-8/12 mt-6 md:mt-0 mb-20 ">
              <div className="w-full md:w-10/12 m-auto">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Kontakt;
